import { Image } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { parseHtml, toWebp, useScrollspy } from "../../../utils/common";
import Select from "react-select";
import dynamic from "next/dynamic";
import FaqSection from "../faq/faq";

const ConnectNowModal = dynamic(() => import("../modals/ConnectNowModal"));
const GetResourceRateModal = dynamic(() =>
	import("../modals/GetResourceRateModal")
);
const GetBusinessModal = dynamic(() => import("../modals/GetBusinessModal"));
const BlogCta = dynamic(() => import("./blog-cta"));
// const BookConsultant = dynamic(() => import('../../services/service-book-consultant/bookconsultant'))

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

function BlogMigration(props) {
	const [navBarOptions, setNavBarOptions] = useState([]);
	const [showConnectModal, setShowConnectModal] = useState(false);
	const [showRateModal, setShowRateModal] = useState(false);
	const [showBusinessModal, setShowBusinessModal] = useState(false);

	let block = props.block;
	let faq = props?.faq;
	let keyPoints = block?.Keypoint || [];
	let faqObject = {
		id: "blog-faq-key-points",
		class: "blog-faq-key-points",
		display_title: faq?.short_title,
	};

	useEffect(() => {
		if (faq?.faq?.length && !keyPoints.find((ele) => ele.id === faqObject.id)) {
			keyPoints.push(faqObject);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	let authors = props.authors;

	const CustomOption = ({ innerProps, innerRef, label, value }) => {
		return (
			<div className="select-tab">
				<a
					className="select-tab-item"
					href={value}
					ref={innerRef}
					{...innerProps}
				>
					{label}
				</a>
			</div>
		);
	};

	const setOptions = () => {
		let options = [];
		keyPoints.forEach((ele) => {
			options.push({
				value: `#${ele.id}-anchor`,
				label: ele.display_title,
			});
		});
		setNavBarOptions(options);
	};

	useEffect(() => {
		setOptions();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const activeIndex = useScrollspy(keyPoints, 110, keyPoints[0].id, "id");

	return (
		<section className="blog-migration-section  bg-one home-padding-new pt-0">
			<div className="blog-migration-inner">
				<div className="container">
					<div className="blog-migration-cantent">
						{navBarOptions.length ? (
							<Select
								isSearchable={false}
								options={navBarOptions}
								defaultValue={navBarOptions[0]}
								components={{ Option: CustomOption }}
								className="stage-select-dropdown d-none"
								styles={{
									singleValue: (base) => ({
										...base,
										padding: 10,
										background:
											"var(--bg-header-light-fixed)",
										color: "var(--color-sub-heading)",
										display: "flex",
									}),
									control: (base) => ({
										...base,
										background:
											"var(--bg-header-light-fixed)",
										borderColor: "var(--border) !important",
										boxShadow: "none !important",
										marginTop: "0",
									}),
									indicatorSeparator: (base) => ({
										...base,
										background: "transparent",
									}),
									menu: (base) => ({
										...base,
										background:
											"var(--bg-header-light-fixed)",
										border: "0",
										boxShadow: "none",
										border: "1px solid #8dd0ff",
										margin: "0",
									}),
								}}
							/>
						) : null}
						<div className="row g-0">
							<div className="col-lg-3 col-md-4">
								<div className="blog-migration-name">
									<div>
										<ul className="nav nav-tabs">
											{keyPoints.map((ele, index) => {
												return (
													<li
														className="nav-item"
														key={index}
													>
														<a
															className={`nav-link ${
																activeIndex ===
																ele.id
																	? "active"
																	: null
															}`}
															href={`#${ele.id}-anchor`}
														>
															{ele.display_title}
															<span className="arrow"></span>
														</a>
													</li>
												);
											})}
										</ul>
									</div>
								</div>
							</div>

							<div className="col-lg-9 col-md-8 ">
								<div className="blogcontent-detail">
									{keyPoints?.map((element, index) => {
										if (element.id === faqObject.id) {
											return null;
										}
										return (
											<div
												className="blog-migration-key-points"
												key={index}
												id={element.id}
											>
												<a
													id={`${element.id}-anchor`}
													className="anchor-top"
												/>
												<h2>{element.title}</h2>
												{element?.Image?.data ? (
													<Image
														src={toWebp(
															`${baseUrl}${element?.Image?.data.attributes.url}`
														)}
														alt={`${baseUrl}${element?.Image?.data.attributes.alt}`}
													/>
												) : null}
												{element?.text
													? parseHtml(element?.text)
													: null}
												{element?.cta ? (
													<BlogCta
														block={element?.cta}
														handleShowConnect={() =>
															setShowConnectModal(
																true
															)
														}
														handleShowRate={() =>
															setShowRateModal(
																true
															)
														}
														handleShowBusiness={() =>
															setShowBusinessModal(
																true
															)
														}
													/>
												) : null}
											</div>
										);
									})}
								</div>
                {faq?.faq?.length && (
                  <div className={faqObject.class} id={faqObject.id}>
                    <a
                      id={`${faqObject.id}-anchor`}
                      className="anchor-top"
                    />
                    <FaqSection data={faq} />
                  </div>
                )}
							</div>
						</div>
					</div>
					<div className="blog-about-box">
						<div className="row">
							<div className="col-lg-3 col-md-4">
								<div className="blog-about-heading">
									<h2 className="h4 font-semibold">More About Author</h2>
								</div>
							</div>
							<div className="col-lg-9 col-md-8">
								{authors?.data?.map((ele, i) => {
									return (
										<div key={i} className="row blog-about">
											<div className="col-lg-12 col-md-12 col-12">
												<div className="author-data-row">
													{ele?.attributes
														?.author_data?.image
														?.data && (
														<div className="blog-about-img">
															<Image
																src={toWebp(
																	`${baseUrl}${ele?.attributes?.author_data?.image?.data?.attributes?.url}`
																)}
																alt={`${baseUrl}${ele?.attributes?.author_data?.image?.data?.attributes?.alt}`}
															/>
														</div>
													)}
													<div className="blog-about-content">
														<h3 className="h4">
															{
																ele?.attributes
																	?.author_data
																	?.fullname
															}
														</h3>

														{ele?.attributes
															?.author_data
															?.description
															? parseHtml(
																	ele
																		?.attributes
																		?.author_data
																		?.description,
																	true
															  )
															: ""}
													</div>
												</div>
											</div>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				</div>
			</div>
			<ConnectNowModal
				show={showConnectModal}
				handleClose={() => setShowConnectModal(false)}
			/>
			<GetResourceRateModal
				show={showRateModal}
				handleClose={() => setShowRateModal(false)}
			/>
			<GetBusinessModal
				show={showBusinessModal}
				handleClose={() => setShowBusinessModal(false)}
			/>
		</section>
	);
}

export default BlogMigration;

